import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppShell } from '@/components/AppShell';
import { RequireAuth } from '@/components/RequireAuth';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { EnquiriesPage } from '@/pages/EnquiriesPage';
import { EventsPage } from '@/pages/EventsPage';
import { EventDetailPage } from '@/pages/EventDetailPage';
import { QuotesPage } from '@/pages/QuotesPage';
import { QuickQuotePage } from '@/pages/QuickQuotePage';
import { InvoicesPage } from '@/pages/InvoicesPage';
import { CalendarPage } from '@/pages/CalendarPage';
import { CatalogPage } from '@/pages/CatalogPage';
import { ClientsPage } from '@/pages/ClientsPage';
import { ImportReviewPage } from '@/pages/ImportReviewPage';
import { StaffPage } from '@/pages/StaffPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireAuth>
                <AppShell />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="enquiries" element={<EnquiriesPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="events/:id" element={<EventDetailPage />} />
            <Route path="quotes" element={<QuotesPage />} />
            <Route path="quotes/quick" element={<QuickQuotePage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="calendar" element={<CalendarPage />} />
            <Route path="catalog" element={<CatalogPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="import-review" element={<ImportReviewPage />} />
            <Route path="staff" element={<StaffPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
